import { fromJS } from 'immutable';
import * as cnt from '../../../../components/contracting/__storeFiles__/constants';
import moment from 'moment';

const initialState = fromJS({
  contractId: '',
  open: false,
  saving: false,
  sendingContracts: false,
  title: '',
  templateName: '',
  newDraftStartDate: '',
  newDraftEndDate: '',
  duplicateTemplateName: false,
  BCCSelf: false,
  includeNotes: false,
  includeGeneralNote: false,
  includeMultiLocNotes: false,
  multiLocNote: '',
  sendUpdatesMessage: '',
  sourceTemplatePeriod: {},
  shouldClearDates: undefined,
});

export default function publishDraftDialog(state = initialState, { type, payload }) {
  switch (type) {
    case 'GET_CONTRACT_LEFT_NAV':
      return state.set('contractId', payload.contractId)
        // .set('sendUpdatesMessage', `I’ve made some important changes to ${payload.locationName}'s ${moment(payload.startDate).format('DD MMM YYYY')} - ${moment(payload.endDate).format('DD MMM YYYY')} rates.`)
        .set('defaultSubject', `Updated: ${payload.locationName}'s ${moment(payload.startDate).get('year')}-${moment(payload.endDate).get('year')} rates`);
    case 'SEND_UPDATES_IN_PUBLISH_DRAFT_DIALOG':
      return state.merge(fromJS({
        title: 'Send Updates',
        open: true,
        sendUpdatesSubject: state.get('defaultSubject'),
        sendUpdatesMessage: '',
      }));
    case 'UPDATE_PROPS_IN_PUBLISH_DRAFT_DIALOG':
      return state.merge(fromJS(payload));
    case '{contracting} ADD_DRAFT_TO_QUEUE_SUCCESS':
    case 'PUBLISH_TEMPLATE_DRAFT_SUCCESS':
      return state.merge(fromJS({
        publishingDraft: false,
        open: false,
        title: '',
      }));
    case 'OPEN_AS_SAVE_CONTRACT_AS_TEMPLATE':
      return state.merge(fromJS({
        contractId: payload.contractId,
        sourceTemplatePeriod: payload.contractYear,
        newDraftStartDate: payload.contractYear.startDate,
        newDraftEndDate: payload.contractYear.endDate,
        templateId: payload.templateId,
        isDummyTemplate: payload.isDummyTemplate,
        title: 'Save Template',
        open: true,
      }));
    case 'CHECK_READINESS_BEFORE_DOWNLOADING_DRAFT_PDF':
      return state.merge(fromJS({
        contractId: payload.contractId,
        title: 'Download PDF',
        open: true,
        checkingContractReadiness: true,
      }));
    case 'NOT_ENOUGH_FREE_CONTRACTS':
      return state.setIn(['errors', 'freeContractError'], true).set('title', 'Errors');
    case 'ON_BCC_SELF_CHECK':
      return state.set('BCCSelf', payload.checked);
    case 'INCLUDE_NOTES_CHECK':
      return state.set('includeNotes', payload.checked);
    case 'INCLUDE_MULTI_LOC_NOTES_CHECK':
      return state.set('includeMultiLocNotes', payload.checked);
    case 'INCLUDE_GENERAL_NOTE_CHECK':
      return state.set('includeGeneralNote', payload.checked);
    case 'ON_TEXTFIELD_CHANGE_PUBLISH_DRAFT_DIALOG':
      return state.set(payload.key, payload.value).set('duplicateTemplateName', false);
    case 'SAVING_TEMPLATE_AFTER_DRAFT_PUBLISHED':
      return state.set('saving', true);
    case 'SHOW_CONTRACTING_ERROR_STRING':
      return state.set('saving', false);
    case 'SAVING_NEW_TEMPLATE_FAILED_BECAUSE_DUPLICATES':
      return state.set('duplicateTemplateName', true).set('saving', false);
    case 'SAVED_TEMPLATE_AFTER_DRAFT_PUBLISHED':
      return state.set('saving', false)
                  .set('saveAsNewTemplateFinished', true)
                  .set('newDraft', fromJS(payload.newDraft));
    case '{dummy_account} makeACopyForBuyer_SUCCESS':
      return state.set('makeACopySuccessPayload', fromJS(payload));
    case 'CLOSE_PUBLISH_DRAFT_DIALOG':
      return initialState.set('defaultSubject', state.get('defaultSubject'));
    case `${cnt.REVIEW_MY_RATES_DRAFT}_SUCCESS`:
      return state.set('reviewRateEmailSent', true);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/contracting/dialogs/dialog-reducers/publish-draft-dialog-reducer.js